import { render, staticRenderFns } from "./FirebaseNotif.vue?vue&type=template&id=5497405b&"
import script from "./FirebaseNotif.vue?vue&type=script&lang=js&"
export * from "./FirebaseNotif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports